export default __webpack_public_path__ + "static/media/TRUE.20ecf835.svg";